import { withSentryRouting } from '@sentry/react'
import { useSelector } from 'react-redux'
import { Redirect, Route } from 'react-router-dom'
import routeMemo from 'router/routeMemo'
import { isAuthenticated } from 'state/Auth'

const InstrumentedRoute = withSentryRouting(Route)

/**
 * A wrapper for <Route> that redirects to the login screen if you're not yet authenticated.
 */
function PrivateRoute({ children, component: Component, render = null, ...routeProps }) {
	const isAuth = useSelector(isAuthenticated)
	return (
		<InstrumentedRoute {...routeProps} render={({ location }) =>
			isAuth?
				(children || (render? render({ location }) : false) || <Component location={routeProps.location}/>) :
				(<Redirect to={{ pathname: '/login', state: { from: location } }} />)
		} />
	)
}

export default routeMemo(PrivateRoute)
